import { render, staticRenderFns } from "./AdminWohnungNew.vue?vue&type=template&id=5c6cf1a5&scoped=true&"
import script from "./AdminWohnungNew.vue?vue&type=script&lang=js&"
export * from "./AdminWohnungNew.vue?vue&type=script&lang=js&"
import style0 from "./AdminWohnungNew.vue?vue&type=style&index=0&lang=css&"
import style1 from "./AdminWohnungNew.vue?vue&type=style&index=1&id=5c6cf1a5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c6cf1a5",
  null
  
)

export default component.exports